module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "to-user text-dark"
  }, [_c('h1', {
    staticClass: "to-user__headline",
    class: {
      'only-print': !_vm.showHeadline
    }
  }, [_vm._v(_vm._s(_vm.user.name) + ", " + _vm._s(_vm.schoolYear)), (_vm.version.vTitle) ? _c('span', {
    staticClass: "to-d-pill"
  }, [_vm._v(_vm._s(_vm.version.vTitle))]) : _vm._e()]), _vm._v(" "), (_vm.userNorm.length > 0) ? _c('table', {
    staticClass: "d-table marg-1-bottom d-table__overview"
  }, [_c('thead', [_c('tr', [_c('th', [_c('h4', [_vm._v(_vm._s(_vm.$t('vue2.task_versions.annual_norm')))])]), _vm._v(" "), _c('th', {
    staticClass: "is-number"
  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.userNormFormatted), function(item, idx) {
    return (idx < _vm.userNormFormatted.length - 1) ? _c('tr', {
      key: item.title
    }, [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
      staticClass: "is-number"
    }, [_vm._v(_vm._s(item.value))])]) : _vm._e()
  }), 0), _vm._v(" "), _c('tfoot', _vm._l((_vm.userNormFormatted), function(item, idx) {
    return (idx === _vm.userNormFormatted.length - 1) ? _c('tr', {
      key: item.title
    }, [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
      staticClass: "is-number"
    }, [_vm._v(_vm._s(item.value))])]) : _vm._e()
  }), 0)]) : _vm._e(), _vm._v(" "), (Object.keys(_vm.userPoolsFormatted).length > 0) ? _c('table', {
    staticClass: "d-table marg-1-bottom d-table__overview"
  }, [_c('thead', [_c('tr', [_c('th', [_c('h4', [_vm._v(_vm._s(_vm.i18n['pools']))])]), _vm._v(" "), _c('th', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.assigned')))])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.userPoolsFormatted), function(pool, prop) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(prop))]), _vm._v(" "), _c('td', {
      staticClass: "is-number"
    }, [_vm._v("\n        " + _vm._s(pool) + "\n      ")])])
  }), _vm._v(" "), (_vm.rest) ? _c('tr', [_c('td', [_vm._v("Rest")]), _vm._v(" "), _c('td', {
    staticClass: "is-number"
  }, [_vm._v("\n        " + _vm._s(_vm.rest) + "\n      ")])]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.schoolSettingShownOwnPools && _vm.schoolSettingShownOwnPools.length > 0) ? _c('UserTasksOverviewOwnPools', {
    attrs: {
      "schoolSettingShownOwnPools": _vm.schoolSettingShownOwnPools,
      "isShowScheduled": false,
      "userTasks": _vm.tasksByMasterType
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tasksByMasterType && _vm.tasksByMasterType.length > 0) ? _c('TaskOverviewUserTasks', {
    attrs: {
      "user": _vm.user,
      "tasks": _vm.tasks,
      "tasksByMasterType": _vm.tasksByMasterType,
      "schoolThresholdToHideTaskHours": _vm.schoolThresholdToHideTaskHours,
      "isHideTaskHoursUnderThreshold": _vm.isHideTaskHoursUnderThreshold,
      "canEditTasks": _vm.canEditTasks
    },
    on: {
      "editTask": _vm.onEditTask
    }
  }) : _vm._e(), _vm._v(" "), (_vm.canEditNotes && _vm.userIdNumber) ? _c('SubjectsDistributionUserAgreements', {
    attrs: {
      "userId": _vm.userIdNumber,
      "userAgreements": _vm.userAgreements,
      "isReadAgreements": false
    }
  }) : (_vm.userAgreements && _vm.userAgreements.length > 0) ? _c('div', {
    staticClass: "to-agreements"
  }, [_c('div', {
    staticClass: "to-agreements__header"
  }, [_c('h4', [_vm._v(_vm._s(_vm.i18n['notes']))])]), _vm._v(" "), _c('div', {
    staticClass: "to-agreements__body",
    domProps: {
      "innerHTML": _vm._s(_vm.userAgreements)
    }
  })]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-438256ad!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/TaskOverview/TaskOverviewUser.vue
// module id = 1882
// module chunks = 1